import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const FeesAndCharges = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="feesandcharges"
            prevLink={ROUTE_NAME.FAQ_RISK_MANAGEMENT}
            prevTitle={dict.riskManagement}
            nextLink={ROUTE_NAME.FAQ_DEFAULT_AND_RECOVERY}
            nextTitle={dict.defaultAndRecovery}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.feesAndCharges}
                        </h3>
                    </div>
                    <p>
                        <strong>
                            {dict.feesAndChargesTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.feesAndChargesTitle1Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.feesAndChargesTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.feesAndChargesTitle2Text1}
                    </p>
                    <p>
                        {dict.feesAndChargesTitle2Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.feesAndChargesTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.feesAndChargesTitle3Text1}
                    </p>
                    <p>
                        {dict.feesAndChargesTitle3Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.feesAndChargesTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.feesAndChargesTitle4Text1}
                    </p>
                    <p>
                        {dict.feesAndChargesTitle4Text2}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default FeesAndCharges;
